import {
  TextField,
  FormControl,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";
import isEmail from "validator/lib/isEmail";
import {  useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from "../CountForm.module.css"
import { useDispatch } from "react-redux";
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { CHUser, UserType, getUserTypeFromString } from "../../tsClasses/CHTypes";
import { RootState } from "../../store/store";
import FetchAvatar from "../../functions/FetchAvatar";
import UpdateUserFunc from "../../functions/UpdateUserFunc";
import LoadingModal from "../../modals/LoadingModal";
import SuccessModal from "../../modals/SuccessModal";
import BasicModal from "../../modals/BasicModal";
import CHeader from "../../button/CHeader";
import ProfileAvatar from "../../button/ProfileAvatar";
import ButtonCo from "../../modals/ButtonCo";


type UpdateUserProps = {
  userToUpdate: CHUser;
  action: () => void;
};

export default function UpdateUserForm(props: UpdateUserProps) {

  const [isEmailValid, setisEmailValid] = useState(true);
  const [isFirstNameValid, setisFirstNameValid] = useState(true);
  const [isLastNameValid, setisLastNameValid] = useState(true);
  const [isMobilePhoneValid, setisMobilePhoneValid] = useState(true);
  const [isEmailBlur, setisEmailBlur] = useState(false);
  const [isFirstNameBlur, setisFirstNameBlur] = useState(false);
  const [isLastNameBlur, setisLastNameBlur] = useState(false);
  const [isMobilePhoneBlur, setisMobilePhoneBlur] = useState(false);
  const [isErrorModalOpen, setisErrorModalOpen] = useState(false);
  const [errorTitle, setErrorTitle] = useState("Error");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoadingModalOpen, setisLoadingModalOpen] = useState(false);
  const [isSuccessModallOpen, setisSuccessModallOpen] = useState(false);
  const [avatarURL, setAvatarURL] = useState("/images/users/avatars/no_image.png");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const allInputsValid = isEmailValid && isFirstNameValid && isLastNameValid;

  const userToken: string | null = useSelector(
    (state: RootState) => state.user.userToken
  );

  useEffect(() => {
    getAvatarURL();
  }, [props.userToUpdate, userToken, ],);


  const getAvatarURL = () => {
    FetchAvatar(props.userToUpdate.avatar, userToken).then(async (res) => {
      if (res != null) {
        const imageUrl = URL.createObjectURL(res);
        setAvatarURL(imageUrl);
      }
    });
  };


  const handleEmailChange = (e: { target: { value: string; name: any } }) => {
    if (isEmail(e.target.value)) {
      setisEmailValid(true);
    } else {
      setisEmailValid(false);
    }

    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleFirstNameChange = (ev: {
    target: { value: string | any[]; name: any };
  }) => {
    if (ev.target.value.length >= 2) {
      setisFirstNameValid(true);
    } else {
      setisFirstNameValid(false);
    }

    setInputs((prevState) => ({
      ...prevState,
      [ev.target.name]: ev.target.value,
    }));
  };

  const handleLastNameChange = (ev: {
    target: { value: string | any[]; name: any };
  }) => {
    if (ev.target.value.length >= 2) {
      setisLastNameValid(true);
    } else {
      setisLastNameValid(false);
    }

    setInputs((prevState) => ({
      ...prevState,
      [ev.target.name]: ev.target.value,
    }));
  };

  const rgxZIP = /^[0-9]*$/;

  const handleMobilePhoneChange = (ev: {
    target: { value: string; name: any };
  }) => {
    if (ev.target.value.length >= 10) {
      setisMobilePhoneValid(true);
    } else {
      setisMobilePhoneValid(false);
    }

    if (rgxZIP.test(ev.target.value) && ev.target.value.length < 11) {
      setInputs((prevState) => ({
        ...prevState,
        [ev.target.name]: ev.target.value,
      }));
    }
  };

  const handleAvatarChange = (imageLink: string) => {
    setInputs((prevState) => ({
      ...prevState,
      avatar: imageLink,
    }));

  };

  const handleSelectUserTypeChange = (ev: { target: { value: string ; name: any; }; }) => {
    setInputs((prevState) => ({
      ...prevState,
      [ev.target.name]: getUserTypeFromString(ev.target.value),
    }));
  };

  const handleChangePasswordClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    navigate("/ChangePasswordForm")
  };

  const handleActiveChange = (e: { target: { checked: boolean; name: any } }) => {
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: (e.target.checked),
    }));
  }

  const [inputs, setInputs] = useState({
    userId: props.userToUpdate.userId,
    firstName: props.userToUpdate.firstName,
    lastName: props.userToUpdate.lastName,
    userType: props.userToUpdate.userType,
    email: props.userToUpdate.email,
    mobilePhone: props.userToUpdate.mobilePhone,
    password: "",
    avatar: props.userToUpdate.avatar,
    active: props.userToUpdate.active,
  });

  function delay(ms: number | undefined) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }

  const handelOnSubmit = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (allInputsValid) {
      setisLoadingModalOpen(true);
      const userToUpdate: CHUser = {
        userId: props.userToUpdate.userId,
        password: inputs.password,
        email: inputs.email,
        userType: inputs.userType,
        firstName: inputs.firstName,
        lastName: inputs.lastName,
        mobilePhone: inputs.mobilePhone,
        avatar: inputs.avatar,
        active: inputs.active,
      };

      let propsToSend = {
        userToUpdate: userToUpdate,
        userToken: userToken!,
      };

      UpdateUserFunc(propsToSend).then(async (res) => {
        setisLoadingModalOpen(false);
        if (!res.includes("Error") || res == "gotErr") {
          setisSuccessModallOpen(true);
          await delay(1500);
          setisSuccessModallOpen(false);
          setInputs({
            userId: 0,
            firstName: "",
            lastName: "",
            userType: UserType.COUNTING,
            email: "",
            mobilePhone: "",
            password: "",
            avatar: "",
            active: false,
          });
          props.action();
        }

        if (res.includes("Error")) {
          let error = JSON.parse(res);
          let errorMSG = error.value;
          setErrorTitle("Error");
          setErrorMessage(errorMSG);
          setisErrorModalOpen(true);
        }
        if (res == "Unauthorized") {
          let errorMSG = "Unauthorized Action";
          setErrorTitle("Unauthorized");
          setErrorMessage(errorMSG);
          setisErrorModalOpen(true);
        }
        if (res == "gotErr") {
          setErrorTitle("Server issues");
          setErrorMessage("Please try again in few minutes");
          setisErrorModalOpen(true);
        }
      });
    }
  };

  return (
    <div className={classes.main_form_div}>
      <LoadingModal open={isLoadingModalOpen}></LoadingModal>
      <SuccessModal open={isSuccessModallOpen} />
      <BasicModal
        open={isErrorModalOpen}
        onClose={() => setisErrorModalOpen(false)}
        onConfirm={() => setisErrorModalOpen(false)}
        title={errorTitle}
        message={errorMessage}
      />
      <CHeader type={2}>עדכן פרופיל</CHeader>
      <ProfileAvatar
        onChange={handleAvatarChange}
        userAvatar={avatarURL}
      />
      <br></br>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              value={inputs.firstName}
              error={isFirstNameBlur && isFirstNameValid === false}
              onBlur={() => setisFirstNameBlur(true)}
              onChange={handleFirstNameChange}
              name="firstName"
              type="text"
              helperText="(נדרש)"
              label="שם פרטי"
              variant="outlined"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              value={inputs.lastName}
              error={isLastNameBlur && isLastNameValid === false}
              onBlur={() => setisLastNameBlur(true)}
              name="lastName"
              onChange={handleLastNameChange}
              type="text"
              helperText="(נדרש)"
              label="שם משפחה"
              variant="outlined"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              error={isEmailBlur && isEmailValid === false}
              onBlur={() => setisEmailBlur(true)}
              value={inputs.email}
              name="email"
              placeholder=""
              helperText="(נדרש)"
              onChange={handleEmailChange}
              label="כתובת דואל"
              variant="outlined"
            />
          </FormControl>
        </Grid>
      
        <Grid item xs={12}>
        <FormControl fullWidth>
        <InputLabel id="userTypeSelect-label">תפקיד</InputLabel>
              <Select
                label="תפקיד"
                labelId="userTypeSelect-label"
                id="userTypeSelect"
                name="userType"
                value={inputs.userType}
                onChange={handleSelectUserTypeChange}
                variant="outlined"
              >
                <MenuItem value="ADMINISTRATOR">Administrator</MenuItem>
                <MenuItem value="MANAGER">מנהל ספירה</MenuItem>
                <MenuItem value="COUNTING">מבצע ספירה</MenuItem>
                </Select>
                </FormControl>
        </Grid>
        <Grid item xs={12}>
          
        <FormControl fullWidth>
        <FormControlLabel
          control={
            <Switch
  checked={inputs.active}
  onChange={handleActiveChange}
  inputProps={{ 'aria-label': 'controlled' }}
  name="active"
/>
          }
          label="משתמש פעיל"
        />
        
</FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              value={inputs.mobilePhone}
              error={isMobilePhoneBlur && isMobilePhoneValid === false}
              onBlur={() => setisMobilePhoneBlur(true)}
              name="mobilePhone"
              onChange={handleMobilePhoneChange}
              type="text"
              helperText="(נדרש)"
              label="טלפון נייד"
              variant="outlined"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <ButtonCo
            type={"submit"}
            onClick={handelOnSubmit}
            disabled={!allInputsValid}
          >
            עדכן פרופיל
          </ButtonCo>
          </Grid>
          <Grid item xs={12}>
          <FormControl fullWidth>
            <ButtonCo  type={"submit"}
            onClick={handleChangePasswordClick}>החלפת סיסמא</ButtonCo>
          </FormControl>

          <Grid item xs={12}>

<IconButton onClick={props.action}>
<ArrowBackIosOutlinedIcon  color="primary" />

</IconButton>

        </Grid>
      
        </Grid>
      </Grid>
    </div>
  );
}
